var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('optional-tag', {
    attrs: {
      "tag": "li",
      "active": _vm.hasMultipleSections
    }
  }, [_c('div', {
    class: _vm.classes
  }, [(_vm.section.title) ? _c('p', {
    staticClass: "Polaris-ActionList__Title"
  }, [_vm._v("\n            " + _vm._s(_vm.section.title) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "Polaris-ActionList__Actions"
  }, _vm._l((_vm.section.items), function(item) {
    return _c('polaris-action-list-item', {
      attrs: {
        "content": item.content,
        "action": _vm.wrapAction(item)
      }
    })
  }))])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-264fadfc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-264fadfc","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisActionListSection.vue
// module id = 144
// module chunks = 0